import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f9fa400"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "app-mask" }
const _hoisted_2 = { class: "request" }
const _hoisted_3 = { class: "title" }
const _hoisted_4 = { class: "content" }
const _hoisted_5 = { class: "submit" }

import fy2Api from '@/api/fy2Api';
import { computed, onMounted, reactive } from 'vue';
import { useStore } from 'vuex';
import i18, { State as I18State } from '@/store/i18';


export default /*#__PURE__*/_defineComponent({
  emits: ["close"],
  setup(__props, { emit: emits }: { emit: ({
    (e: 'close'): void
}), expose: any, slots: any, attrs: any }) {

const store = useStore()
const i18data = computed<I18State>(() => store.state[i18.name])
const channelLang = computed(() => i18data.value.texts[i18data.value.lang.list[i18data.value.lang.now]].channel)

const temp = reactive({
    content: '',
    url: '',
})


onMounted(async () => {
    let r = await fy2Api.channelRequest()
    temp.content = r.channel_apply_description
    temp.url = r.channel_ad.value
})

function onSubmit() {
    let a = document.createElement('a')
    a.href = temp.url
    a.target = '_blank'
    a.click()
}

function onCancel() {
    emits('close')
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(channelLang).requestChannel), 1),
      _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(temp).content), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("a", {
          class: "cancel",
          onClick: onCancel
        }, _toDisplayString(_unref(channelLang).cancel), 1),
        _createElementVNode("a", {
          class: "ok",
          onClick: onSubmit
        }, _toDisplayString(_unref(channelLang).ok), 1)
      ])
    ])
  ]))
}
}

})